import { useEffect, useState } from "react";
import { onAuthChange } from "../firebase";
import { subscribeInbox } from "../services/notificationInbox";
import { countUnread, sortInboxByNewest, type InboxItem } from "../utils/inbox";

// Subscribes to the signed-in user's inbox and exposes the sorted items plus
// the unread count (#133). Tracks auth state so it (re)subscribes when the uid
// appears — on web, auth.currentUser is null for a moment after a page reload
// while the session restores, so reading it once at mount would leave the inbox
// permanently empty.
export default function useInbox(): {
  items: InboxItem[];
  unreadCount: number;
} {
  const [items, setItems] = useState<InboxItem[]>([]);

  useEffect(() => {
    let unsubInbox: (() => void) | undefined;
    const unsubAuth = onAuthChange((user) => {
      unsubInbox?.();
      unsubInbox = undefined;
      setItems([]);
      if (user?.uid) {
        unsubInbox = subscribeInbox(user.uid, (next) =>
          setItems(sortInboxByNewest(next)),
        );
      }
    });
    return () => {
      unsubInbox?.();
      unsubAuth();
    };
  }, []);

  return { items, unreadCount: countUnread(items) };
}
